import { FinalGridContainer, FinalGridItem } from '@portals/core/src/components/FinalGrid/FinalGrid';
import { LoadingDots } from '@portals/core/src/components/LoadingDots/LoadingDots';
import React, { useContext, useEffect, useState } from 'react';

import { BookmarkContext } from '../../context';
import { getBookmarkIds } from '../../utils';
import { EstateCardView } from '../';
import { EstateBookmarkedListEmptyList } from './EstateBookmarkedListEmptyList/EstateBookmarkedListEmptyList';

export const EstateBookmarkedList = ({ renderBookmarkButton, renderEstateLink }) => {
  const { bookmarks } = useContext(BookmarkContext);
  const [query, setQuery] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (bookmarks.length > 0) {
      const bookmarkIds = getBookmarkIds(bookmarks);
      setQuery({ estateIds: bookmarkIds, limit: 999 });
    }
    setInitialLoading(false);
  }, [bookmarks]);

  if (initialLoading) {
    return (
      <FinalGridContainer>
        <FinalGridItem md={12} lg={12} sx={{ textAlign: 'center' }}>
          <LoadingDots />
        </FinalGridItem>
      </FinalGridContainer>
    );
  }
  if (query && bookmarks.length > 0) {
    return (
      <EstateCardView
        estateSearchParameters={query}
        renderBookmarkButton={renderBookmarkButton}
        renderEstateLink={renderEstateLink}
        isBookmarkedList={true}
      />
    );
  }

  return <EstateBookmarkedListEmptyList />;
};

export default EstateBookmarkedList;
